$(document).ready(function(){
	if(document.querySelector('.js-articles-displayer') != null){
		if(document.querySelector('.js-partnership-displayer') == null){
			console.log("only about-us articles");	
			
		var artTagAll = document.querySelectorAll('span.artcl_tag');
		var artTag = [];
		
		var arrOfArrs = [];
		
		var checkNewArticleGallery = document.getElementById('newArticleGallery');
		var tagsBtnContainer = document.getElementById('deskTags');
		var tagsSelectContainer = document.getElementById('mobileTags');
		
		var loadingMoreBtn = document.querySelector('.articles_loading_more_section');
		
		var phone = window.matchMedia('(max-width: 767.98px)');
		var tablet = window.matchMedia('(max-width: 1080px)');
		var desktop = window.matchMedia('(max-width: 2560px)');
		
		var artToShowNum = 0;
		var artToLoad = 0;
		
		
		
			if(phone.matches){
				artToShowNum = 3;	
				artToLoad = 1;
			}else if(tablet.matches){
				artToShowNum = 4;
				artToLoad = 2;
			}else if(desktop.matches){
				artToShowNum = 6;
				artToLoad = 3;
			}
		
		for(var i=0; i < artTagAll.length; i++){
			if(!artTag.includes(artTagAll[i].innerText)){
			artTag.push(artTagAll[i].innerText);
			}
		}
		
		arrOfArrs.push("ALL");
		arrOfArrs.push(document.querySelectorAll('.article_component'));
		
		for(var j=0; j<artTag.length; j++){
			arrOfArrs.push(artTag[j]);
			arrOfArrs.push(document.querySelectorAll(".article_component[data-tag='"+artTag[j]+"']"));
		}
		
		if(phone.matches && (checkNewArticleGallery === null || checkNewArticleGallery === undefined)){
			for(var k=0; k<artTag.length; k++){
				var tagOption = document.createElement("option");
				tagOption.innerHTML = artTag[k];
				tagOption.setAttribute("tag", artTag[k]);
				tagsSelectContainer.appendChild(tagOption);
			}
			tagsSelectContainer.addEventListener("change", function(){
				displayArticles(this.options[this.options.selectedIndex].getAttribute("tag"), artToShowNum);
			});
		}
		
		if(tablet.matches || desktop.matches || checkNewArticleGallery !== null){
			for(var k=0; k<artTag.length; k++){
				var tagBtn = document.createElement("div");
				
				var tagIcon = document.querySelector(".article_component[data-tag='"+artTag[k]+"']").getAttribute("data-icon");
				
				tagBtn.classList.add("articles_tag");
				tagBtn.innerHTML = "<span class=\"artcl_tag_icon "+tagIcon+"\"></span><p class=\"title_category\">"+ artTag[k] +"</p>"
				tagBtn.setAttribute("tag", artTag[k]);
				tagsBtnContainer.appendChild(tagBtn);
				tagBtn.addEventListener("click", function(){
					document.querySelector('.articles_tag.selected').classList.remove("selected");
					this.classList.add("selected");
					displayArticles(this.getAttribute("tag"), artToShowNum);
				});
			}
		}
		
		
		document.querySelector('.articles_tag[tag="ALL"]').addEventListener('click', function(){
			document.querySelector('.articles_tag.selected').classList.remove("selected");
			this.classList.add("selected");
		
			displayArticles(this.getAttribute("tag"), artToShowNum);
			
		});
		
		function displayArticles(tag, aTS){
			var allArts = arrOfArrs.indexOf("ALL")+1;
			var artGroup = arrOfArrs.indexOf(tag)+1;
		    
			for(var i=0; i < arrOfArrs[allArts].length; i++){
				arrOfArrs[allArts][i].classList.add("hide");  
			}
		
			for(var j=0; j < aTS && j < arrOfArrs[artGroup].length; j++){
				console.log("i'm showing from this group: " + arrOfArrs[artGroup-1]);
				arrOfArrs[artGroup][j].classList.remove("hide");
			}
		
			if(arrOfArrs[artGroup].length <= aTS){
				loadingMoreBtn.classList.add("hide");
			}else{
				loadingMoreBtn.classList.remove("hide");
			}
			loadingMoreBtn.setAttribute("more-tag", tag);
		}
		
		if(document.querySelector('div[data-edit="true"]') == null){
		document.querySelector('.articles_tag[tag="ALL"]').click();
		}
		
		loadingMoreBtn.addEventListener("click", function(){
			if(this.getAttribute("more-tag") != "ALL"){
				loadMoreArticlesGeneric(this.getAttribute("more-tag"), artToLoad);
			}else{
				loadMoreArticlesAll(artToLoad)
			}
		});
		
		function loadMoreArticlesGeneric(tag, aTL){
				var allHiddenArt = document.querySelectorAll(".article_component.hide[data-tag='"+tag+"']");
		
				for(var i = 0; i < aTL; i++){
					if(i >= allHiddenArt.length){
						break
					}
					allHiddenArt[i].classList.remove("hide");
				}
				
				if(document.querySelectorAll(".article_component.hide[data-tag='"+tag+"']").length == 0){
					loadingMoreBtn.classList.add("hide");
				}
			}
		
		function loadMoreArticlesAll(aTL){
				var allHiddenArt = document.querySelectorAll(".article_component.hide");
		
				for(var i = 0; i < aTL; i++){
					if(i >= allHiddenArt.length){
						break
					}
					allHiddenArt[i].classList.remove("hide");
				}
				
				if(document.querySelectorAll(".article_component.hide").length == 0){
					loadingMoreBtn.classList.add("hide");
				}
			}
		}
	}
});